import { atomWithStorage } from 'jotai/utils';
import { rawStringStorage } from './storage';

export const versionAtom = atomWithStorage('version', '', rawStringStorage, {
    getOnInit: true,
});
